export default __webpack_public_path__ + "static/media/icons8-hot-springs.8880922f.svg";